import { memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/lib/v2/components';
import { TooltipProps } from '@/lib/v2/components/Tooltip/Tooltip';
import { Card } from '@/lib/v3/components';

import CardActivity from './components/CardActivity';
import Skeleton from './components/Skeleton';

import useActivityUserInsights from '@/modules/InsightsModule/hooks/useActivityUserInsights';
const ActivityUser = () => {
  const { t } = useTranslation(['insights']);
  const { data, loading, haveData, getData, wordings } = useActivityUserInsights();

  const tooltips = useMemo(
    () => ({
      center: {
        alignment: 'center' as TooltipProps['alignment'],
      },
      end: {
        alignment: 'end' as TooltipProps['alignment'],
      },
    }),
    []
  );

  useEffect(() => {
    if (haveData) return;
    void getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card id="card-activity">
      <Card.Header>
        <Text color="black" fontWeight="medium" variant="headline">
          {t('ACTIVITY_USER.title')}
        </Text>
      </Card.Header>
      <Card.Content>
        {!haveData || loading ? (
          <Skeleton />
        ) : (
          <div className="flex h-full flex-row gap-4">
            <div className="flex-1">
              <CardActivity
                data={data.dac}
                id={'activity-dac'}
                tooltip={tooltips.center}
                wordings={wordings['dailyActivity']}
              />
            </div>
            <div className="flex-1">
              <CardActivity
                data={data.wac}
                id={'activity-wac'}
                tooltip={tooltips.center}
                wordings={wordings['weeklyActivity']}
              />
            </div>
            <div className="flex-1">
              <CardActivity
                data={data.mac}
                id={'activity-mac'}
                tooltip={tooltips.end}
                wordings={wordings['monthlyActivity']}
              />
            </div>
          </div>
        )}
      </Card.Content>
    </Card>
  );
};

export default memo(ActivityUser);
